import { render, staticRenderFns } from "./SKUTable.vue?vue&type=template&id=39c164d2"
import script from "./SKUTable.vue?vue&type=script&lang=js"
export * from "./SKUTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports